
import { defineComponent } from 'vue'
import { shortenLargeNumber, formatUSD } from '~/utils/string'
import { centsToDollars } from '~/utils/billing'

export default defineComponent({
  name: 'AiReviewUsageCard',
  props: {
    creditsUsed: {
      type: Number,
      default: 0
    },
    creditsAllocated: {
      type: Number,
      default: 0
    },
    prReviewedCount: {
      type: Number,
      default: 0
    },
    commitReviewedCount: {
      type: Number,
      default: 0
    },
    ossTargetsMonitoredCount: {
      type: Number,
      default: 0
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    legacyPlanType: {
      type: String,
      default: null,
      validator: (v: string | null) => v === null || ['starter', 'business'].includes(v)
    }
  },
  emits: ['upgrade-plan', 'migrate-plan', 'paused-click'],
  computed: {
    usagePercentage(): number {
      if (this.creditsAllocated === 0) return 0
      return Math.round((this.creditsUsed / this.creditsAllocated) * 100)
    },
    progressBarWidth(): number {
      return Math.min(100, this.usagePercentage)
    },
    isPaused(): boolean {
      return this.creditsAllocated > 0 && this.creditsUsed >= this.creditsAllocated
    },
    progressBarColor(): string {
      if (this.usagePercentage > 90) return 'bg-cherry'
      if (this.usagePercentage > 60) return 'bg-honey-500'
      return 'bg-robin-500'
    },
    formattedCreditsUsed(): string {
      return formatUSD(centsToDollars(this.creditsUsed))
    },
    formattedCreditsAllocated(): string {
      return formatUSD(centsToDollars(this.creditsAllocated))
    },
    formattedPrCount(): number | string {
      return shortenLargeNumber(this.prReviewedCount)
    },
    formattedCommitCount(): number | string {
      return shortenLargeNumber(this.commitReviewedCount)
    },
    formattedOssTargets(): number | string {
      return shortenLargeNumber(this.ossTargetsMonitoredCount)
    },
    legacyInfoText(): string {
      if (this.legacyPlanType === 'business') {
        return 'AI Review is not available on your current plan. Migrate to the new Team plan at no cost.'
      }
      return 'AI Review is not available on your current plan. Please upgrade to the new Team plan.'
    }
  }
})
